import axios from "./httpClient";
import * as _ from "lodash";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { TTerminal } from "../AppState/overagesFilterFormActions";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @returns - Array of Terminal List of type TTerminal[]
 */
export const getTerminals = async (): Promise<TTerminal[]> => {
  try {
    const response = await axios.get(getUrl(ApiType.TERMINAL), {
      headers: { "Content-Type": "application/json" },
    });
    return _.get(response, "data.data", []);
   } catch (error: any) {
      return throwApiError(error, ErrorMessages.terminalAPIError, { badRequestOrder: "errorsFirst" });
    }
};

